import axios from 'axios'
import { ACCOUNT_KEY } from '../providers/AccountProvider'
import { Routes } from '../Routes'

const interceptor = {
  setupInterceptors: () => {
    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        return response
      },
      function (error) {
        if (
          error.response?.status === 403 &&
          error.response?.data?.error_code === 'eAuthExpired'
        ) {
          // Removes info on user, redirects and saves error message
          localStorage.removeItem('session_user')
          localStorage.removeItem('session_token')
          localStorage.removeItem('version')
          localStorage.removeItem(ACCOUNT_KEY)
          localStorage.setItem('403_error', error.response?.data.error_message)
          window.location.href = Routes.LOGOUT
          // TODO: this is triggered, we should revisit how to handle this in a better way in a future ticket with more time
        }
        if (
          error.response?.status === 400 &&
          error.response?.data?.error_code === 'eInvalidAccount' &&
          error.response?.data?.error_message ===
            'You have not supplied a valid account id. Please consult the API docs.'
        ) {
          //Somewhere, the account got deleted from the storage, redirect to login. (if user still has a session it will see the select account, otherwise it will need to login again)
          window.location.href = Routes.LOGIN
          // TODO: this is triggered, we should revisit how to handle this in a better way in a future ticket with more time
        }
        return Promise.reject(error)
      }
    )
  }
}
export default interceptor
//You have not supplied a valid account id. Please consult the API docs.
